/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { action } from "@ember/object";
import Component from "@glimmer/component";
import type { EmberChangeset } from "ember-changeset";
import type FollowUpReason from "parog-web/models/follow-up-reason";

interface Signature {
  Args: {
    changeset: EmberChangeset;
    followUpReasonId: FollowUpReason["id"];
  };
}

export default class TreatmentHistoryEditionFormBreastCancerFormSurgerySection extends Component<Signature> {
  get surgeryTypes(): Array<string> {
    switch (this.args.followUpReasonId) {
      case "onco-lung-cancer":
        return ["pulmonary", "cerebral", "adrenal"];
      case "onco-pancreatic-cancer":
        return [
          "prostatectomy",
          "lymph-node-dissection",
          "pulpectomy",
          "orchiectomy"
        ];
      default:
        return [
          "auxiliary-cleaning",
          "mastectomy",
          "quadrantectomy",
          "tumorectomy",
          "oncoplasty",
          "pamectomy",
          "prophylactic-surgery",
          "enlargement",
          "reconstruction",
          "sentinel-node",
          "pac-installation",
          "prophylactic-annexectomy",
          "ambulatory",
          "hospitalisation",
          "external",
          "prostatectomy",
          "lymph-node-dissection",
          "pulpectomy",
          "orchiectomy"
        ];
    }
  }

  get surgeries() {
    return this.args.changeset.get("surgerySurgeries");
  }

  @action
  onChangesetUpdate(changeset: EmberChangeset) {
    changeset.execute();
    this.setAsDirty();
  }

  setAsDirty() {
    this.args.changeset.set("surgerySurgeries", [].concat(this.surgeries));
  }
}
